export function matrixLocalpart(userId: string): string {
  const match = userId.match(/^@([^:\s]+):\S+$/);
  return match ? match[1]! : userId;
}

export function displayNameForUser(displayName: string | null | undefined, userId: string): string {
  const value = displayName?.trim();
  if (!value) return matrixLocalpart(userId);
  return matrixLocalpart(value);
}
